module.exports = __webpack_public_path__ + "media/src/public/img/popup-heart-slide-26276603beaa41ff04751178040df621.png";